import type { FC, ReactNode } from 'react';

import { StyledTourCardContentContainer } from './StyledComponents';

interface TourCardContentContainerProps {
  children: ReactNode;
  size?: 'sm' | 'md';
}

const TourCardContentContainer: FC<TourCardContentContainerProps> = ({ children, size = 'sm' }) => (
  <StyledTourCardContentContainer padding={size === 'sm' ? 'xs' : 'sm'}>{children}</StyledTourCardContentContainer>
);

export type { TourCardContentContainerProps };
export default TourCardContentContainer;
